import React from "react";
import Svg, {
  Path,
  Defs,
  G,
  LinearGradient,
  Stop,
  ClipPath,
  Rect
} from "react-native-svg";

export default function TrackFabIcon() {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_track)">
        <Path
          d="M15.922 13.0776V12.9498C15.9214 12.7798 15.9661 12.6126 16.0514 12.4655C16.1368 12.3184 16.2597 12.1966 16.4076 12.1127C18.8039 10.8028 19.6729 7.63978 19.986 5.38413C20.0299 5.0755 20.007 4.76104 19.919 4.46199C19.831 4.16295 19.6798 3.88627 19.4756 3.65066C19.2715 3.41504 19.0192 3.22596 18.7358 3.0962C18.4523 2.96643 18.1443 2.89899 17.8326 2.89844H8.98252C8.67108 2.89807 8.3632 2.96466 8.07974 3.0937C7.79629 3.22275 7.5439 3.41123 7.33967 3.64636C7.13544 3.88149 6.98416 4.15779 6.89607 4.45652C6.80797 4.75524 6.78514 5.06942 6.82911 5.37774C7.11666 7.60144 7.9793 10.7197 10.3116 12.0616C10.4865 12.1611 10.6319 12.3052 10.7329 12.4792C10.834 12.6532 10.887 12.8509 10.8867 13.0521V13.0521C10.8867 13.2826 10.8244 13.5089 10.7063 13.7069C10.5881 13.9048 10.4187 14.0672 10.2158 14.1767C7.93457 15.4675 7.11666 18.4899 6.81633 20.6625C6.77718 20.9686 6.80389 21.2796 6.89467 21.5745C6.98545 21.8695 7.13821 22.1416 7.34271 22.3727C7.54721 22.6039 7.79874 22.7886 8.08044 22.9147C8.36215 23.0407 8.66753 23.105 8.97613 23.1035H17.8262C18.1399 23.1025 18.4497 23.0339 18.7344 22.9022C19.0192 22.7705 19.2721 22.5789 19.4759 22.3405C19.6798 22.102 19.8298 21.8224 19.9156 21.5207C20.0014 21.2189 20.0211 20.9022 19.9732 20.5922C19.6601 18.4516 18.823 15.4803 16.5674 14.2023C16.3693 14.0894 16.205 13.9256 16.0915 13.7279C15.978 13.5301 15.9195 13.3056 15.922 13.0776Z"
          stroke="url(#paint0_linear)"
          strokeWidth="2.45767"
          strokeMiterlimit="10"
        />
      </G>
        <Defs>
          <LinearGradient
            id="paint0_linear"
            x1="6.79883"
            y1="7.28026"
            x2="18.6168"
            y2="23.0667"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_track">
            <Rect
              width="16.403"
              height="23.4"
              fill="white"
              transform="translate(5.19995 1.30078)"
            />
          </ClipPath>
        </Defs>
    </Svg>
  );
}
